<template>
    <div class="text-left font-bold">
        <div v-if="has_not_started">
            Départ prévu le {{ parcours.date_course }} à {{ parcours.heure_depart_theorique }}
        </div>
        <div v-else-if="is_running">
            Parti le {{ parcours.date_course }} à {{ parcours.heure_depart }}
        </div>
        <div v-else-if="is_finished">
            Course terminée
        </div>
    </div>
</template>

<script>
export default {
    props: ['parcours'],
    computed: {
        has_not_started() {
            return this.parcours.depart == 0;
        },
        is_running() {
            return this.parcours.depart == 1 && this.parcours.terminee == 0;
        },
        is_finished() {
            return this.parcours.terminee == 1;
        }
    }
}
</script>

<style lang="scss" scoped></style>